export default class PriceFormatter {
    constructor(format) {
        this.priceFormat = JSON.parse(format);
    }

    format(price, roundZeroes) {
        price = parseFloat(price).toFixed(2);
        if (!this.priceFormat.params.preferDecimals || roundZeroes) {
            price = String(price).split('.')[1] === '00' ? parseFloat(price).toFixed(0) : price;
        }
        const formattedPrice = this.priceFormat.format.replace(/{price}/, price);

        return {
            dangerouslySetInnerHTML : {
                __html : formattedPrice
            }
        };
    }

    formatParts(price, beforeCallback) {
        price = parseFloat(price).toFixed(2);
        const priceParts = String(price).split('.');
        const cents = priceParts[1] === '00' ? (
            this.priceFormat.params.preferDecimals ? '00' : ''
        ) : priceParts[1];
        const formattedPrice = `<span>${priceParts[0]}</span><sup><small>${cents}</small></sup>`;

        let beforePart = '';
        if (typeof beforeCallback === 'function') {
            beforePart = beforeCallback();
        }

        return {
            dangerouslySetInnerHTML : {
                __html : beforePart + this.priceFormat.format.replace(/{price}/, formattedPrice)
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/helpers/PriceFormatter.js